import { render, staticRenderFns } from "./canteenShop.vue?vue&type=template&id=3e46a397&scoped=true"
import script from "./canteenShop.vue?vue&type=script&lang=js"
export * from "./canteenShop.vue?vue&type=script&lang=js"
import style0 from "./canteenShop.vue?vue&type=style&index=0&id=3e46a397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46a397",
  null
  
)

export default component.exports